export default {
      id: "favorite-wire-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#favorite-wire",
      toString: function () {
        return this.url;
      }
    }